import { render, staticRenderFns } from "./Altura.vue?vue&type=template&id=082b822c"
import script from "./Altura.vue?vue&type=script&lang=js"
export * from "./Altura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports